"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _AjaxContentWithContext = require("./AjaxContentWithContext");

var _AjaxContentWithContext2 = _interopRequireDefault(_AjaxContentWithContext);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

// eslint-disable-next-line require-await
exports.default = function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(domNode, rehydrateChildren) {
    var readData, children, failedContent, rehydrationProps;
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            readData = function readData(prop) {
              var data = domNode.getAttribute("data-" + prop);

              return data ? JSON.parse(data) : null;
            };

            _context.next = 3;
            return rehydrateChildren(domNode);

          case 3:
            children = _context.sent;
            failedContent = readData("failed-content-message") ? readData("failed-content-message") : "Failed to retrieve content";
            rehydrationProps = {
              autoLoad: false,
              failedContent: failedContent,
              loadingLabel: readData("loading-label"),
              location: readData("location"),
              minHeight: readData("min-height")
            };
            return _context.abrupt("return", _react2.default.createElement(
              _AjaxContentWithContext2.default,
              rehydrationProps,
              children
            ));

          case 7:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, undefined);
  }));

  return function (_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();